module.exports = __webpack_public_path__ + "static/media/btn-back-arrow-hover.df5c4cee.svg";